module.exports = __webpack_public_path__ + "static/social_textcat-e5d6b02ce7c382e16878c3bfe506f540.jpg";